<template>
  <main>
    <h4 class="title is-4 m-t-40">
      {{this.$t('wallet.stacksAccount')}}
      <span v-if="linkedAccount & linkedAccount.account" :title="`Attached EOS account: ${linkedAccount.account}@${linkedAccount.permission}`">• {{linkedAccount.account}}</span>
    </h4>
    <wallet-providers></wallet-providers>
  </main>
</template>
<script>

import WalletProviders from '@/components/wallet/providers'
import {mapState, mapGetters} from 'vuex'

export default {
  components: {WalletProviders},
  computed: {
    ...mapState('sigproviders', [
      'authenticated',
      'message',
      'wallet'
    ]),
    ...mapState('wallet', [
      'linkedAccount'
    ]),
    ...mapGetters('sigproviders', [
      'providers',
      'account'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/eos-account.vue